// extracted by mini-css-extract-plugin
export var container = "image-comparison-slider-module--container--12a9b";
export var image = "image-comparison-slider-module--image--c666e";
export var leftText = "image-comparison-slider-module--leftText--eaade";
export var rightText = "image-comparison-slider-module--rightText--2e858";
export var textOverlay = "image-comparison-slider-module--textOverlay--1caa4";